(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/communication-settings-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/communication-settings-panel.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const putCustomersSettingsAsync = svs.myProfile.react.shared.customerSettingsService.putCustomersSettingsAsync;
const _svs$myProfile$react$ = svs.myProfile.react.shared.helpers,
  clearAllUrlParam = _svs$myProfile$react$.clearAllUrlParam,
  makeSetting = _svs$myProfile$react$.makeSetting,
  getCAndI = _svs$myProfile$react$.getCAndI;
const Form = svs.ui.reactForm.Form;
const trackListChanges = svs.myProfile.react.shared.tracking.trackListChanges;
const _svs$myProfile$react$2 = svs.myProfile.react.shared.dialogs,
  showCustomersOldLinkError = _svs$myProfile$react$2.showCustomersOldLinkError,
  showSettingsTechnicalError = _svs$myProfile$react$2.showSettingsTechnicalError;
const CheckboxItem = svs.myProfile.react.shared.components.CheckboxItem;
const useCustomerSettings = svs.myProfile.react.shared.hooks.useCustomerSettings;
const setPlayerSettingsData = svs.myProfile.react.store.pd.actions.setPlayerSettingsData;
const backendName = svs.myProfile.constants.backendName;
const _svs$myProfile$react$3 = svs.myProfile.react.pages.communicationSettings.communicationSettings.components,
  Advertising = _svs$myProfile$react$3.Advertising,
  MarketResearch = _svs$myProfile$react$3.MarketResearch,
  VegasCommunication = _svs$myProfile$react$3.VegasCommunication,
  CommunicationSettingsSkeleton = _svs$myProfile$react$3.CommunicationSettingsSkeleton;

const CommunicationSettingsPanel = () => {
  const dispatch = ReactRedux.useDispatch();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerDetails),
    playerSettings = _ReactRedux$useSelect.playerSettings;
  const _useState = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)),
    _useState2 = _slicedToArray(_useState, 1),
    isPlayerLoggedIn = _useState2[0];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldShowApiError = _useState4[0],
    setShouldShowApiError = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasApiErrorShowed = _useState6[0],
    sethasApiErrorShowed = _useState6[1];
  const _useState7 = useState({
      c: '',
      i: ''
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    cAndI = _useState8[0],
    setCAndI = _useState8[1];
  useCustomerSettings(setShouldShowApiError);
  useEffect(() => {
    if (shouldShowApiError && !hasApiErrorShowed) {
      sethasApiErrorShowed(true);
      showSettingsTechnicalError();
    }
  }, [shouldShowApiError, hasApiErrorShowed]);
  useEffect(() => {
    const getData = async () => {
      var _svs$my_profile_react;
      svs.myProfile.logger.debug("**** Player isPlayerLoggedIn: ".concat(isPlayerLoggedIn ? 'Yes' : 'No'));
      const unInLoggedData = (_svs$my_profile_react = svs.my_profile_react.data) === null || _svs$my_profile_react === void 0 ? void 0 : _svs$my_profile_react.communication_settings_react;
      svs.myProfile.logger.debug('get svs.myProfile.data?.communication_settings_react:');
      if (unInLoggedData && unInLoggedData.dataError) {
        clearAllUrlParam();
        showCustomersOldLinkError();
      }
      if (unInLoggedData && unInLoggedData.data) {
        setCAndI(getCAndI());
        dispatch(setPlayerSettingsData(unInLoggedData.settings));
      }
    };
    getData();
  }, [isPlayerLoggedIn]);
  const handleCheckbox = async id => {
    svs.myProfile.logger.debug("**** main handleOnChange id: ".concat(id));
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), {}, {
      [id]: !playerSettings[id]
    });
    const c = cAndI.c,
      i = cAndI.i;
    try {
      const _await$putCustomersSe = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])], c, i),
        status = _await$putCustomersSe.status,
        error = _await$putCustomersSe.error;
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackListChanges(newPlayerSettingsData, playerSettings, 'communication');
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  return React.createElement(Form, null, !playerSettings && React.createElement(CommunicationSettingsSkeleton, null), playerSettings && React.createElement(React.Fragment, null, React.createElement(MarketResearch, null, React.createElement(CheckboxItem, {
    id: backendName.MARKET_RESEARCH,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Ja, ni f\xE5r g\xE4rna fr\xE5ga mig om jag vill delta."
  })), React.createElement(Advertising, null, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxItem, {
    id: backendName.ADVERTING_EMAIL,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "E-post"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxItem, {
    id: backendName.ADVERTISING_SMS,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Textmeddelande (SMS)"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxItem, {
    id: backendName.ADVERTISING_LETTER,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Brev"
  })), React.createElement(CheckboxItem, {
    id: backendName.ADVERTISING_APP_NOTIFICATION,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Notiser via app"
  })), React.createElement(VegasCommunication, null, React.createElement(CheckboxItem, {
    id: backendName.VEGAS_COMMUNICATION,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Ja tack, jag vill ha marknadsf\xF6ring fr\xE5n Vegas."
  }))));
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.CommunicationSettingsPanel = CommunicationSettingsPanel;

 })(window);